import { ProjectCreate } from "@/graphql/generated/graphql";

export const DEFAULT_COUNTRY = "United Kingdom";
export const DEFAULT_PROJECT_STATE: ProjectCreate = {
  title: "Untitled Project",
  code: "",
  description: "",
  clientReps: [],
  clientId: "",
  companyId: "",
  status: "",
  addresses: [],
  projectUsers: [],
  tagIds: [],
  contractTypeIds: [],
  activities: [],
  settings: [
    { name: "enable-weekends", value: "false" },
  ],
};
